import { Button } from "@mui/material";
import { classes } from "portal/theme/theme";
import { MuiColor } from "common/hooks/useMuiColor";
import React, { FC, PropsWithChildren, ReactNode } from "react";

interface SelectionButtonProps extends PropsWithChildren {
  isSelected: boolean;
  isFocused?: boolean;
  subSection?: boolean;
  onClick: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
}
export const SelectionButton: FC<SelectionButtonProps> = ({
  isSelected,
  isFocused,
  subSection,
  onClick,
  onMouseEnter,
  onMouseLeave,
  startIcon,
  endIcon,
  children,
}) => {
  const sectionColor = (): MuiColor | "inherit" => {
    if (isSelected) {
      return "info";
    }
    if (isFocused) {
      return "secondary";
    }
    return "inherit";
  };
  const getVariant = (): "contained" | "text" => {
    if (isSelected || isFocused) {
      return "contained";
    }
    return "text";
  };
  return (
    <Button
      color={sectionColor()}
      className={classes("justify-start text-left", subSection && "pl-4")}
      startIcon={startIcon}
      endIcon={endIcon}
      disableElevation
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      variant={getVariant()}
      fullWidth
    >
      {children}
    </Button>
  );
};
